var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"process-main"},[_vm._v(" 请根据物流情况确认收货，并按下一步要求提交晒图或客观的宝贝评价，注意看下商家给的评价内容再下一页， "),_c('span',{staticClass:"text-red-500"},[_vm._v("不要复制不应该有的内容，不然要承担相应的责任。")])])
}]

export { render, staticRenderFns }